import { createAPI } from '@common'

export default {
  //导出
  postNisCircleExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt00ojt0djsdmf0fyqpsu', 'post', config),
  //社圈参与明细
  getNisCirclePromoterList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qspnpufs.mjtu', 'GET', config),
  //预览社圈
  postNisCirclePreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qsfwjfx', 'post', config),
  //查询社圈分类下帖子总览
  getNisCircleStatistics: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0tubujtujdt', 'get', config),
  //还原帖子
  postNisCirclePostRollBack: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0spmmCbdl', 'post', config),
  // 下载帖子接口
  postExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0fyqpsu', 'post', config),
  //查询帖子详情
  getNisCirclePostDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0efubjm', 'get', config),
  postReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0sfkfdu', 'post', config),
  //查询公告详情
  getNisCircleNoticeDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0opujdf0efubjm', 'get', config),
  postNisCircleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0efmfuf', 'post', config),
  //查询所有通过审核的社圈
  getNisCircleRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0sfdpnnfoe', 'get', config),
  // 推荐社圈
  postNisCircleRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0sfdpnnfoe', 'post', config),

  postNisCirclePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qbtt', 'post', config),
  postNisCirclePostConvert2Article: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0dpowfsu3Bsujdmf', 'POST', config),
  // 查询流程记录
  getLogs: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0f60bdujpot0mpht', 'get', config),
  getGroups: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut', 'get', config, vConfig),
  //查询圈子列表接口
  getListByCat: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0mjtuCzDbu', 'get', config, vConfig),
  postGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut', 'post', config),
  putGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut', 'put', config, {
      timeout: 120000
    }),
  deleteGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut0efmfuf', 'post', config),
  //获取分组详情
  getGroupsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut0efubjm', 'get', config),
  //获取回收设圈列表
  getGroupsCatsRecycle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut0sfdzdmf', 'get', config),
  //还原社圈分组
  postGroupsCatsRestore: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut0sftupsf', 'post', config),
  // 获取审核通过的社圈列表
  getNisCircle: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf', 'get', config, vConfig),

  // 创建社圈
  postNisCircle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf', 'post', config),
  // 创建帖子
  postNisCirclePost: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu', 'post', config),
  // 修改帖子
  putNisCirclePost: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu', 'put', config),
  // 创建公告
  postNisCircleNotice: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0opujdf', 'post', config),
  // 修改公告
  putNisCircleNotice: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0opujdf', 'put', config),
  // 修改社圈
  putNisCircle: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf', 'put', config),
  // 获取社圈详情
  getNisCircleDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0efubjm', 'get', config),
  // 爆料配置保存
  postSaveNisTipoffConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dpogjh', 'post', config),
  // 获取爆料详情
  getNisTipoffDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efubjm', 'get', config),
  // 获取爆料详情(处理过视频的
  getNisTipoffConvert: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efubjm0dpowfsu', 'get', config),
  // 删除爆料
  deleteNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efmfuf', 'post', config),
  // 预览报料
  previewNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0qsfwjfx', 'post', config),
  // 转为稿件
  transferNisCircle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0dpowfsu3Bsujdmf', 'post', config),
  // 社圈帖子加精设置
  postNisCirclePostPromotionConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0qspnpujpoDpogjh', 'post', config),
  //获取帖子加精设置
  getNisCirclePostPromotionConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0qspnpujpoDpogjh', 'get', config),
  // 社圈帖子加精
  postNisCirclePostPromote: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0qspnpuf', 'post', config),
  // 社圈帖子取消加精
  postNisCirclePostDemote: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0efnpuf', 'post', config),
  // 转为稿件
  generateArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0hfofsbufBsujdmf', 'post', config),
  // 帖子预览
  postPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0qsfwjfx', 'post', config),

  // 新建社圈推荐
  // postColumnModules: (config) =>
  //   createAPI('customEncryptApiName-1/0w20dpmvno0npevmft', 'post', config),
  postColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft', 'post', config),
  //还原推荐
  postColumnModulesRollBack: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft0spmmCbdl', 'post', config),
  // 修改社圈推荐
  // putColumnModules: (config) => createAPI('customEncryptApiName-1/0w20dpmvno0npevmft', 'put', config),
  putColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft', 'put', config),
  // 获取社圈推荐详情
  // getColumnModules: (config) => createAPI('customEncryptApiName-1/0w20dpmvno0npevmft', 'GET', config),
  getColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft', 'GET', config),
  // 新建、修改页面初始化参数
  getColumnModulesInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft0joju', 'GET', config),
  // 社圈推荐内容排序
  // getColumnModulesSort: (config) =>
  //   createAPI('customEncryptApiName-1/0w20dpmvno0npevmft0tpsu', 'POST', config)
  getColumnModulesSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft0tpsu', 'POST', config),
  //社圈自定义推荐更新排序
  updateModuleOrder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0npevmft0vqebufNpevmfPsefs',
      'POST',
      config
    ),
  // 添加圈子管理员
  createCircleManager: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0nbobhfs0dsfbuf0djsdmf', 'POST', config),
  // 添加圈子管理员(新)-后端通过计算对比新旧数据增减
  submitCircleManager: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0nbobhfs0tvcnju0djsdmf', 'POST', config),
  // 删除圈子管理员
  deleteCircleManager: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0nbobhfs0efmfuf', 'DELETE', config),
  // 获取社圈&话题&帖子&通知模块的权限
  getNisCirclePermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut0qfsnjttjpoDjsdmfUzqft',
      'get',
      config
    ),
  // 创建话题
  addNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd', 'post', config),
  // 修改话题
  editNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd', 'put', config),
  // 删除话题
  deleteNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0efmfuf', 'post', config),
  // 获取话题详情
  getNisGambitDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0efubjm', 'get', config),
  //话题排序
  orderNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0psefs', 'post', config),
  //话题审核通过
  passNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0qbtt', 'post', config),
  //话题审核不通过
  rejectNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0sfkfdu', 'post', config),
  //话题预览
  previewNisGambit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0qsfwjfx', 'post', config),
  // 获取社圈分组管理员角色
  getCircleRoles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0dbut0spmft', 'GET', config),

  // IP定位
  getIpLocation: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0nbq0jqMpdbujpo', 'GET', config),
  // 行政区域
  getDistrict: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0nbq0ejtusjdu', 'GET', config),
  // 关键字搜索
  getPlaceText: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0nbq0qmbdf0ufyu', 'GET', config),
  // 获取高德地图是否启用
  getAmapEnable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0nbq0fobcmfe', 'GET', config),
}
